import { useHistory } from 'react-router-dom';
import { RolesTableRow } from './RolesTableRow';
import { RolesTableHeader } from './RolesTableHeader';
import { RolesTableSkeleton } from './RolesTableSkeleton';
import { EmptyState } from '@personnel/presentation/components/shared';
import type { Role } from '@personnel/domain/entities';
interface RolesTableProps {
  roles: Role[];
  isLoading?: boolean;
  onDeleteRole?: (roleId: string) => void;
}

/**
 * Roles Table Component
 *
 * Main table component displaying roles list.
 * Uses Semantic Styles Pattern for maintainability.
 *
 * @param {RolesTableProps} props - Component properties
 * @returns {React.ReactElement} Roles table component
 */
const styles = {
  container: 'border border-border rounded-lg w-full',
};

export const RolesTable = ({ roles, isLoading = false, onDeleteRole }: RolesTableProps): React.ReactElement => {
  const history = useHistory();

  if (isLoading) {
    return <RolesTableSkeleton />;
  }

  if (roles.length === 0) {
    return <EmptyState context="roles" onAction={() => history.push('/roles/create')} />;
  }

  return (
    <div className={styles.container}>
      {/* Table Header */}
      <RolesTableHeader />

      {/* Table Body */}
      <div>
        {roles.map((role) => (
          <RolesTableRow key={role.uuid} onDelete={onDeleteRole} role={role} />
        ))}
      </div>
    </div>
  );
};
